import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ICustomerGroupsFeature } from './customer-groups.feature.state';
import { CustomerGroupsState } from './customer-groups.state';

export const getCustomerGroupsState: MemoizedSelector<ICustomerGroupsFeature, CustomerGroupsState> = createFeatureSelector<
  CustomerGroupsState
>(nameof<ICustomerGroupsFeature>('customerGroupsFeature'));

export const getIsLoading = createSelector(getCustomerGroupsState, (state: CustomerGroupsState) => state.isLoading);
export const getFailures = createSelector(getCustomerGroupsState, (state: CustomerGroupsState) => state.failures);
export const getCustomerGroups = createSelector(getCustomerGroupsState, (state: CustomerGroupsState) => state.customerGroups);
export const getSelectedCustomerGroup = createSelector(getCustomerGroupsState, (state: CustomerGroupsState) => state.selectedCustomerGroup);
